
import React from "react";

export const Contact = (props) => {
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-12">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
               
              </div>
            <div className="contact-item">
              <p>
                <span>
                <i className="fa fa-building"></i> SAM.gov CAGE Code
                </span>{" "}
                {props.data ? props.data.cage : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                <i className="fa fa-building"></i> SAM.gov UEI
                </span>{" "}
                {props.data ? props.data.uei : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
            
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
             
             <p>
               <span>
                 <i className="fa fa-map-marker"></i> Address
               </span>
               {props.data ? props.data.address : "loading"}
             </p>
           </div>
              {}
            </div>
          </div>
          
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.linkedin : "/"}>
                      <i className="fa fa-linkedin"></i>
                    </a>
                  </li>
                  {/* <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li> */}
                  <li>
                    <a href={props.data ? props.data.medium : "/"}>
                      <i className="fa fa-medium"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 Apollo Software Labs LLC
          </p>
        </div>
      </div>
    </div>
  );
};
